const TOPICS = [
  { label: '范马刃牙', hot: true },
  { label: '刃牙道', hot: true },
  { label: '宫本武藏', hot: false },
  { label: '范马勇次郎', hot: true },
  { label: '相扑道', hot: false },
  { label: '死囚篇', hot: false },
  { label: '花山薰', hot: false },
  { label: '烈海王', hot: false },
  { label: '刃牙II', hot: false },
  { label: '愚地独步', hot: false },
  { label: '地下竞技场', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          热门话题
        </h2>
        <p className="text-foreground-600 text-sm md:text-base text-center mb-10">
          刃牙漫画读者最关心的热门标签
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {TOPICS.map((t) => (
            <span
              key={t.label}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {t.label}
              {t.hot && (
                <i className="ri-fire-line text-xs"></i>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}